import { Typography } from 'antd';
import moment from 'moment';

export default function AppCopyright() {
  const year = moment().year();

  return (
    <Typography.Text type="secondary" className="about">
      Copyright © {year} Ultracar Tecnologia e Informação LTDA. Todos os
      direitos reservados.
    </Typography.Text>
  );
}
